import React from 'react';
import ReactPaginate from 'react-paginate';

class Pages extends React.Component {

    constructor(props) {
      super(props)
      this.state = {
        start: 0, //最初は0番目(=最新)の要素から
        current: 0,
        perPage: 50, //1ページには50冊表示
      }
    }

    pageReflesh(){
        this.setState({
            start: 0,
            current: 0
        })
    }

    pageChange(data) {
        let pageNumber = data['selected']; //選択されたページ番号
        this.setState({
            //スタート位置をページ番号 * 1ページあたりの数、とする(例えば2番を選ぶと12 * 1で12番が先頭になる、つまり13番目以降の書籍が表示される)
            start: pageNumber * this.state.perPage,
            current: pageNumber
        })
    }

    render(){
        return (
            <>

            <div className="Pagination">
            <ReactPaginate
                pageCount={Math.ceil(this.props.list.length / this.state.perPage)} //総ページ数。今回は一覧表示したいデータ数 / 1ページあたりの表示数としてます。
                marginPagesDisplayed={2} //先頭と末尾に表示するページの数。今回は2としたので1,2…今いるページの前後…後ろから2番目, 1番目 のように表示されます。
                pageRangeDisplayed={5} //上記の「今いるページの前後」の番号をいくつ表示させるかを決めます。
                onPageChange={this.pageChange.bind(this)} //ページネーションのリンクをクリックしたときのイベント
                containerClassName='pagination' //ページネーションリンクの親要素のクラス名
                pageClassName='page-item' //各子要素(li要素)のクラス名
                pageLinkClassName='page-link' //ページネーションのリンクのクラス名
                activeClassName='current' //今いるページ番号のクラス名。今いるページの番号だけ太字にしたりできます 
                previousLabel='Prev' //前のページ番号に戻すリンクのテキスト
                nextLabel='Next' //次のページに進むボタンのテキスト
                previousClassName='page-item' // '<'の親要素(li)のクラス名
                nextClassName='page-item' //'>'の親要素(li)のクラス名
                previousLinkClassName='page-link'  //'<'のリンクのクラス名
                nextLinkClassName='page-link'　//'>'のリンクのクラス名
                disabledClassName='disabled' //先頭 or 末尾に行ったときにそれ以上戻れ(進め)なくするためのクラス
                breakLabel='...' // ページがたくさんあるときに表示しない番号に当たる部分をどう表示するか
                breakClassName='page-item' // 上記の「…」のクラス名
                breakLinkClassName='page-link' // 「…」の中のリンクにつけるクラス
                forcePage={this.state.current}
            />
            </div>

            {
                this.props.list.slice(this.state.start, this.state.start + this.state.perPage).map(entry => {
                    return (
                    <div className="swiper-slide">
                        <a href={entry.slug} target="_blank" rel="noreferrer">
                            <img 
                                src={"https://s3-ap-northeast-1.amazonaws.com/data.smacmag.net/_images/thumbnail_map/"+entry.id+".png"} 
                                className="thumbnail_img" 
                                onError={(e) => e.target.src = process.env.PUBLIC_URL+'/images/noimage.png'}
                                alt="cluster"
                            />
                            <img 
                                src={process.env.PUBLIC_URL+"/images/flag/"+entry.code.toLowerCase()+".png"}
                                className="flag_img"
                                onError={(e) => e.target.src = process.env.PUBLIC_URL+'/images/flag/sma.jpg'}
                                alt="nationalflag"
                            />
                        </a>
                    </div>
                    ) 
                })
            }


            <div className="Pagination">
            <ReactPaginate
                pageCount={Math.ceil(this.props.list.length / this.state.perPage)} //総ページ数。今回は一覧表示したいデータ数 / 1ページあたりの表示数としてます。
                marginPagesDisplayed={2} //先頭と末尾に表示するページの数。今回は2としたので1,2…今いるページの前後…後ろから2番目, 1番目 のように表示されます。
                pageRangeDisplayed={5} //上記の「今いるページの前後」の番号をいくつ表示させるかを決めます。
                onPageChange={this.pageChange.bind(this)} //ページネーションのリンクをクリックしたときのイベント
                containerClassName='pagination' //ページネーションリンクの親要素のクラス名
                pageClassName='page-item' //各子要素(li要素)のクラス名
                pageLinkClassName='page-link' //ページネーションのリンクのクラス名
                activeClassName='current' //今いるページ番号のクラス名。今いるページの番号だけ太字にしたりできます 
                previousLabel='Prev' //前のページ番号に戻すリンクのテキスト
                nextLabel='Next' //次のページに進むボタンのテキスト
                previousClassName='page-item' // '<'の親要素(li)のクラス名
                nextClassName='page-item' //'>'の親要素(li)のクラス名
                previousLinkClassName='page-link'  //'<'のリンクのクラス名
                nextLinkClassName='page-link'　//'>'のリンクのクラス名
                disabledClassName='disabled' //先頭 or 末尾に行ったときにそれ以上戻れ(進め)なくするためのクラス
                breakLabel='...' // ページがたくさんあるときに表示しない番号に当たる部分をどう表示するか
                breakClassName='page-item' // 上記の「…」のクラス名
                breakLinkClassName='page-link' // 「…」の中のリンクにつけるクラス
                forcePage={this.state.current}
            />
            </div>

            </>
        );
    }
    
}

export default Pages;